<div class="wrap">
    <div class="header">
        <div class="title">
            <fa-icon [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin']" routerLinkActive="router-link-active" appChangeColorTheme attribute="color"></fa-icon>
            <h2>Liste des structures</h2>
        </div>

        <div class="add_search_structure">
            <div class="add_structure" [routerLink]="['/admin/structure/new']" routerLinkActive="router-link-active" appChangeColorTheme [isHover]="true">
                <fa-icon [icon]="getFaIcon('faPlus')" appChangeColorTheme attribute="color"></fa-icon>
                <span>Ajouter une structure</span>
            </div>
            <div class="search_bar">
                <form [formGroup]="searchForm">
                    <input type="text" placeholder="Chercher une structure ..." (input)="applyFilter($event.target.value)"
                        formControlName="keyword">

                </form>

                <fa-icon [icon]="getFaIcon('faTimes')" (click)="resetSearch()" class="faTimes" *ngIf="valueInput"></fa-icon>
                <fa-icon [icon]="getFaIcon('faSearch')" *ngIf="!valueInput"></fa-icon>

            </div>
        </div>
    </div>

    <div class="content">
        <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">


            <ng-container matColumnDef="structureName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="structureName" class="cell_club">Nom de la structure </th>
                <td mat-cell *matCellDef="let element" class="cell_club"> {{element.structureName}} </td>
            </ng-container>

            <ng-container matColumnDef="details">
                <th mat-header-cell *matHeaderCellDef class="cell_action"> Détails </th>
                <td mat-cell *matCellDef="let element" class="cell_action">
                    <fa-icon [icon]="getFaIcon('faInfoCircle')" [routerLink]="['/admin/structure-details']"
                        [queryParams]="{structureKey: element.structureKey}" [matTooltip]="getTooltip('detailsStructure')" appChangeColorTheme attribute="color"></fa-icon>
                </td>
            </ng-container>

            <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef class="cell_action"> Editer </th>
                <td mat-cell *matCellDef="let element" class="cell_action">
                    <fa-icon [icon]="getFaIcon('faPen')" (click)="goEdit(element)" appChangeColorTheme attribute="color"></fa-icon>
                </td>
            </ng-container>



            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;">
            </tr>
        </table>
        <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
            (page)="pageEvent = $event" [color]="color">
        </mat-paginator>
    </div>
  </div>
